// extracted by mini-css-extract-plugin
export default {"mention":"CommentMessage_mention__dvsJ0","link":"CommentMessage_link__EZqqc","reportLink":"CommentMessage_reportLink__DrWO8","reportLinkIcon":"CommentMessage_reportLinkIcon__8Ey5a"};